import React from 'react';
import {MdInfo} from 'react-icons/md';
import {PuddleBag} from '../../hooks/usePuddleForm';
import {
	FormControl,
	FormErrorMessage,
	FormLabel,
	Textarea,
	Icon,
	Tooltip,
} from 'components/ui/chakra';

interface PuddleTextareaProps<TModel, TRequest> {
	label: string;
	fieldName: keyof TRequest;
	form: PuddleBag<TModel, TRequest>;
	isRequired?: boolean;
	placeholder?: string;
	helperText?: string;
}

const PuddleTextarea = <TModel, TRequest>({
	label,
	fieldName,
	form,
	isRequired = false,
	placeholder,
	helperText,
}: PuddleTextareaProps<TModel, TRequest>) => (
	<FormControl isInvalid={form.fieldHasError(fieldName)} isRequired={isRequired}>
		<FormLabel>
			{label}
			{helperText && (
				<Tooltip label={helperText}>
					<span>
						<Icon as={MdInfo} ml={2} />
					</span>
				</Tooltip>
			)}
		</FormLabel>
		<Textarea
			bgColor={isRequired && !form.model ? 'sandstone.50' : 'white'}
			value={
				form.model && form.model[fieldName as unknown as keyof TModel]
					? (form.model[fieldName as unknown as keyof TModel] as string)
					: ''
			}
			onChange={(e) => form.updateField(fieldName, e.target.value)}
			onBlur={(e) => form.validateField(fieldName, e.target.value)}
			placeholder={placeholder}
		/>
		{form.fieldHasError(fieldName) && (
			<FormErrorMessage fontSize='xs'>{form.getFieldError(fieldName)}</FormErrorMessage>
		)}
	</FormControl>
);

export default PuddleTextarea;
